export default "__VITE_ASSET__BlX5TjOb__"